import type { Factor, Level } from '@shared/factors';

const RANK_BG: Record<Level, string> = {
  5: 'bg-rank-5/10 border-rank-5',
  4: 'bg-rank-4/10 border-rank-4',
  3: 'bg-rank-3/10 border-rank-3',
  2: 'bg-rank-2/10 border-rank-2',
  1: 'bg-rank-1/10 border-rank-1',
};

const RANK_TEXT: Record<Level, string> = {
  5: 'text-rank-5',
  4: 'text-rank-4',
  3: 'text-rank-3',
  2: 'text-rank-2',
  1: 'text-rank-1',
};

export function FactorDetailModal({
  factor,
  onClose,
}: {
  factor: Factor;
  onClose: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        className="max-h-[90vh] w-full max-w-3xl overflow-y-auto rounded-lg bg-white p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-4 flex items-start justify-between">
          <div>
            <p className="text-xs text-slate-500">
              因子 #{factor.id} ・ {factor.layer_name} / {factor.category_name}
            </p>
            <h2 className="text-xl font-bold text-slate-800">{factor.name}</h2>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600">
            ✕
          </button>
        </div>

        <div className="mb-4 rounded-md bg-slate-50 p-3 text-sm text-slate-700">
          <span className="font-medium text-slate-500">測定方法:</span> {factor.method}
        </div>

        <div className="space-y-2">
          {([5, 4, 3, 2, 1] as Level[]).map((lv) => {
            const l = factor.levels[lv];
            return (
              <div key={lv} className={`rounded-md border-l-4 p-3 ${RANK_BG[lv]}`}>
                <div className={`mb-1 text-xs font-bold ${RANK_TEXT[lv]}`}>
                  Lv.{lv} {l.name}
                </div>
                <div className="mb-1 text-sm font-medium text-slate-800">
                  判断基準: {l.criteria}
                </div>
                <div className="text-xs text-slate-600">根拠: {l.rationale}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
